import React from 'react';

interface HeaderProps {
  onMenuClick: () => void;
  onCreateChat?: () => Promise<void> | void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onCreateChat }) => {
  return (
    <div className="bg-white border-b border-gray-200">
      {/* メインヘッダー */}
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 lg:hidden"
            aria-label="サイドバーを開く"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          
          <div className="flex items-center space-x-3">
            <div className="flex items-baseline space-x-3">
              <h1 className="text-xl font-semibold text-blue-600">LLMView</h1>
              <span className="hidden sm:inline-block text-sm text-gray-500">AI可視化ツール（オープンベータ）</span>
              <span className="hidden md:inline-flex items-center px-2 py-0.5 rounded-full bg-blue-50 text-xs font-medium text-blue-600 border border-blue-100">
                Open Beta
              </span>
            </div>
            <button
              type="button"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.dispatchEvent(new CustomEvent('open-settings-about'));
                }
              }}
              className="hidden md:inline-flex text-xs text-gray-500 hover:text-gray-800 underline-offset-2 hover:underline"
            >
              開発について
            </button>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          {/* 新規チャット作成ボタン */}
          <button
            onClick={onCreateChat}
            className="px-4 py-2 bg-blue-600 text-white rounded-full text-sm hover:bg-blue-700 transition-colors flex items-center gap-2"
            title="新規チャットを作成"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14"/>
              <path d="M5 12h14"/>
            </svg>
            <span>新規チャット</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
